import SplitDocumentComplianceLayout from './layouts/SplitDocumentComplianceLayout.vue'
import ProductsFirstSplitDocumentComplianceLayout from './layouts/ProductsFirstSplitDocumentComplianceLayout.vue'

const DocumentComplianceLayout = Object.freeze({
    PRODUCTS_FIRST_SPLIT_V1: 'split-products-first-v1',
    SPLIT_V1: 'split-v1',
})

const DEFAULT_DOCUMENT_COMPLIANCE_LAYOUT = DocumentComplianceLayout.SPLIT_V1

const DOCUMENT_COMPLIANCE_LAYOUT_REGISTRY = Object.freeze({
    [DocumentComplianceLayout.PRODUCTS_FIRST_SPLIT_V1]: ProductsFirstSplitDocumentComplianceLayout,
    [DocumentComplianceLayout.SPLIT_V1]: SplitDocumentComplianceLayout,
})

const resolveDocumentComplianceLayout = (layout = null) => (
    DOCUMENT_COMPLIANCE_LAYOUT_REGISTRY[layout || DEFAULT_DOCUMENT_COMPLIANCE_LAYOUT] || null
)

export {
    DEFAULT_DOCUMENT_COMPLIANCE_LAYOUT,
    DocumentComplianceLayout,
    resolveDocumentComplianceLayout,
}
